export const arrayResultMemoizeOptions = {
  memoizeOptions: {
    resultEqualityCheck: (a, b) => a.length === b.length && a.every((item, index) => item === b[index]),
  },
}
